export type VoiceStatus = 'idle' | 'connecting' | 'recording' | 'processing';

export interface VoiceServerEvent {
  type: string;
  status?: VoiceStatus;
  text?: string;
  segment_id?: string;
  code?: string;
  message?: string;
  patch?: VoicePatientPatch;
}

export interface VoicePatientPatch {
  кличка?: string;
  вид?: string;
  порода?: string;
  возраст?: string;
  пол?: string;
  вес?: string;
  жалобы?: string;
}

export function buildVoiceWebSocketUrl(): string {
  const url = new URL('/api/voice', window.location.href);
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
  return url.toString();
}

export function parseVoiceEvent(data: string): VoiceServerEvent | null {
  try {
    const value: unknown = JSON.parse(data);
    if (typeof value !== 'object' || value === null || !('type' in value) || typeof value.type !== 'string') return null;
    return value as VoiceServerEvent;
  } catch {
    return null;
  }
}
